<template>
  <div>
    <el-dialog
      width="900px"
      title="选择供应商"
      :before-close="handleClose"
      :visible.sync="Open"
      :close-on-click-modal="false"
    >
      <BaseTable
        ref="baseTable"
        :fn-init="Fninit"
        :table="table"
        @handleSupplier="handleSupplier"
      />
    </el-dialog>
  </div>
</template>

<script>
  import { defaultSearchOptions } from './config'
  import { supplierChoose } from '@/api/supplier'
  import { productCategoryTreeList } from '@/api/goods/productCategory.js'
  import { listUserOptions } from '@/api/setting/system/user'
  export default {
    components: {},
    props: {
      paramsType: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      let _this = this
      return {
        rowInfo: {},
        Open: true,
        dictData: [],
        table: {
          name: '',
          defaultParams: {},
          selectName: 'supplierId', // 禁用的时候唯一标识radio
          selectData: [],
          showSearchBar: true,
          searchOptions: JSON.parse(JSON.stringify(defaultSearchOptions)),
          canRefresh: false, // 刷新按钮
          showMoreBtns: false, // 展示新增按钮
          options: [
            {
              label: '供应商编码',
              key: 'supplierCode',
              align: 'left',
              type: 'name',
              visible: true,
            },
            {
              label: '供应商名称',
              key: 'supplierName',
              type: 'name',
              align: 'center',
              visible: true,
              overflow: 10,
            },
            {
              label: '供应商简称',
              key: 'shortName',
              type: 'name',
              align: 'center',
              visible: true,
            },
            {
              label: '擅长类目',
              key: 'categoryFullNames',
              minWidth: '100',
              type: 'name',
              align: 'center',
              visible: true,
            },
            {
              label: '对接采购',
              key: 'contactUserNames',
              type: 'name',
              align: 'center',
              visible: true,
            },
          ],
        },

        Fninit: () => {
          return {
            initData(params) {
              return new Promise((resolve) => {
                supplierChoose(
                  this.objectSavekey(params),
                  this.objectDelkey(params)
                ).then((res) => {
                  // 列表颜色池子
                  let arr3 = [
                    '#F0F8FF',
                    '#FFF0F5',
                    '#F0FFF0',
                    '#FFFFE0',
                    '#F5F0FF',
                    '#FAF0E6',
                    '#E0FFFF',
                  ]
                  let groupIdCount = {}
                  res.data.list.forEach((item) => {
                    if (groupIdCount[item.groupId]) {
                      groupIdCount[item.groupId]++
                    } else {
                      groupIdCount[item.groupId] = 1
                    }
                  })

                  let arr2 = Object.keys(groupIdCount).filter(
                    (key) => groupIdCount[key] > 1
                  )
                  let colorIndex = 0
                  let groupColorMap = {} // To store the color for each groupId
                  res.data.list.forEach((item) => {
                    item.contractId = item.supplierId
                    if (arr2.includes(item.groupId)) {
                      if (!groupColorMap[item.groupId]) {
                        // Assign a new color from arr3
                        groupColorMap[item.groupId] =
                          arr3[colorIndex % arr3.length]
                        colorIndex++
                      }
                      // Add rowColor to the item
                      item.rowColor = groupColorMap[item.groupId]
                    }
                  })
                  resolve(res)
                })
              })
            },
            handleChange() {
              if (_this.$refs.baseTable.multipleSelection.length > 0) {
                _this.supplierIdList = []
                _this.$refs.baseTable.multipleSelection.forEach((item) => {
                  _this.supplierIdList.push(item.supplierId)
                })
                _this.openTransform = true
              } else {
                this.msgWarning('请勾选')
              }
            },
            clearOptions() {
              // 重置清空搜索框
              this.table.defaultParams = {}
              this.table.searchOptions = JSON.parse(
                JSON.stringify(defaultSearchOptions)
              )
            },
          }
        },
      }
    },
    created() {
      this.getproductCategoryTreeList()
      this.getlistUserOptions()
    },
    methods: {
      getlistUserOptions() {
        listUserOptions({ userStatus: 1 }).then((res) => {
          res.data.forEach((item) => {
            item.label = item.userName
            item.id = item.userId
          })
          defaultSearchOptions[1].options = res.data
          this.table.searchOptions[1].options = res.data
        })
      },
      getproductCategoryTreeList() {
        productCategoryTreeList({
          categoryStatus: 1,
          levelList: [1, 2, 3],
        }).then((res) => {
          defaultSearchOptions[0].options = res.data
          this.table.searchOptions[0].options = res.data
        })
      },
      handleSupplier(val) {
        this.$emit('handleSupplier', val)
      },
      handleClose() {
        this.$emit('handleSupplier')
      },
    },
  }
</script>
